export default {
    START_HEATING: 'startHeating',
    READY_TO_USE: 'endOfHeating',
    NEAR_END: 'nearEnd',
    FULLY_HEATED: 'fullyHeated',
    BATTERY_CHARGED: 'uiBatteryChargedVibration',
    HAPTIC_PROFILE: 'hapticProfile',
    HAPTIC_DELAY: 'hapticDelay',
};
